import React, {useEffect, useState} from "react";

import IconButton from "../button/IconButton";
import CardTable from "./CardTable";
import ModalForm from "../form/ModalForm";
import XButton from "../button/XButton";
import {Actions} from "../../../client/Actions";
import ConfirmIconButton from "../button/ConfirmIconButton";
import EditButton from "../button/EditButton";
import {ButtonGroup, Col} from "react-bootstrap";
import Table from "./Table";
import InfoButton from "../button/InfoButton";
import { useTranslation } from 'react-i18next';
import AddButton from "../button/AddButton";


const FunctionalTableComponent = ({
                                      setLoader,
                                      onDataUpdate,
                                      title,
                                      creationTitle,
                                      editionTitle,
                                      width,
                                      api,
                                      creationFields,
                                      shadow = true,
                                      editable = false,
                                      details = false,
                                      initialData,
                                      removable = true,
                                      readOnly,
                                      columns,
                                      externalReload,
                                      tableHeader,
                                      editWithPost = false,
                                      editWithId = false,
                                      header,
                                      className,
                                      editionFields,
                                      fromModal,
                                      addFromGroup,
                                      addFromGroupFields,
                                      noCard,
                                      editAction,
                                      detailsAction,
                                      modalSize,
                                      onCreated,
                                      deleteModalTitle,
                                      deleteModalDescription,
                                      addAsList,
                                      additionalButtons,
                                      deleteApi,
                                      beforeSave,
                                      editApi,
                                      createApi,
                                      externalState,
                                      setExternalState,
                                      setExternalReload,
                                      pagination,
                                      customCreate,
                                      actionsInEnd
                                  }) => {
    const { t } = useTranslation();
    const processedColumns = typeof columns === 'function' ? columns(t) : columns;

    const [showModal, setShowModal] = useState(false);
    const [showAddFromGroupModal, setShowAddFromGroupModal] = useState(false);
    const [reload, setReload] = useState(false);

    const [data, setData] = useState([])
    const [editMode, setEditMode] = useState(false)
    const [editionItem, setEditionItem] = useState()


    const loadData = () => {
        if (api) {
            Actions.get(api, dataLoaded)
        }
    }

    const dataChanged = () => {
        loadData()
        if (setExternalReload) {
            setExternalReload(!externalReload)
        }
    }
    const save = (data) => {
        setLoader(true)

        if (beforeSave) {
            data = beforeSave(data)
        }

        if (editMode && !editWithPost) {
            Actions.put(`${editApi || api}${editWithId ? "/" : ""}${editWithId ? data.id : ""}`, data, dataChanged)
        } else {
            Actions.post(createApi || api, addAsList ? [data] : data, (saved) => {
                if (onCreated) {
                    onCreated(saved);
                }
                dataChanged()
            })
        }
    }

    const customDelete = (id) => {
        setLoader(true)
        Actions.delete((deleteApi || api) + "/" + id, {}, dataChanged, undefined, setLoader)
    }

    const dataLoaded = (newData) => {
        setData(newData)
        setLoader(false)
    }

    function closeModal() {
        setShowModal(false)
        setEditMode(false)
        setEditionItem(undefined)
    }

    const actionsColumn = {
        field: "actions",
        label: t("common.actions"),
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history, additionalInformation) {
            return (
                <div className={"d-flex " + (actionsInEnd ? `justify-content-end` : "")}>
                    <ButtonGroup>
                        {removable && !readOnly && <>
                            {api ?
                                <ConfirmIconButton
                                    variant={"outline-primary"}
                                    size={"md"}
                                    tooltip={t("tooltips.delete")}
                                    modalClassName={"second-modal"}
                                    fullIcon={"fa-regular fa-trash-can"}
                                    confirmTitle={deleteModalTitle}
                                    confirmDescription={deleteModalDescription}
                                    onConfirm={() => {
                                        customDelete(row.id)
                                    }}
                                    modalSize={'md'}
                                />
                                :
                                <XButton
                                    onClick={() => {
                                        if (api) {
                                            customDelete(row.id)
                                        } else {
                                            // Ensure 'parameters' and 'setParameters' are available in this scope
                                            setData(prevData => prevData.filter(p => p.tmpId !== row.tmpId));
                                        }
                                    }}
                                />
                            }</>
                        }
                        {
                            editable && !readOnly &&
                            <EditButton
                                onClick={() => {
                                    if (editAction) {
                                        editAction(row.id)
                                    } else {
                                        setEditMode(true)
                                        setShowModal(true)
                                        setEditionItem(row)
                                    }

                                }}
                            />
                        }
                        {
                            details &&
                            <InfoButton
                                onClick={() => {
                                    detailsAction(row.id)
                                }}
                            />
                        }
                        {additionalButtons && !readOnly && additionalButtons(row, reload, setReload)}
                    </ButtonGroup>
                </div>
            );
        }
    };


    useEffect(() => {
        if (onDataUpdate) {
            onDataUpdate(data)
        }

    }, [data])


    useEffect(() => {
        setData(initialData)


    }, [initialData])


    useEffect(loadData, [api, reload, externalReload])


    function prepareTitle(title) {
        return <>
            <div className="float-left mt-2">
                {title}
            </div>

            {!readOnly && (creationFields || customCreate) &&
                <div className="float-right">
                    <AddButton
                        tooltip={t("common.add")}
                        onClick={() => {
                            if (customCreate) {
                                customCreate()
                            } else {
                                setShowModal(true)
                            }
                        }}
                    />
                    {addFromGroup &&
                        <AddButton
                            tooltip={t("actions.add_parameters_from_group")}
                            onClick={() => {
                                setShowAddFromGroupModal(true)
                            }}
                        />
                    }
                </div>
            }
        </>;
    }

    function onSave(newItem, onSaved) {
        if (api) {
            save(newItem)
        } else {
            const toAdd = {...newItem}
            toAdd.tmpId = Math.floor(Math.random() * 101010);

            const tmp = data || [];
            tmp.push(toAdd);


            setData(tmp)

        }
        onSaved();
    }

    function onAddFromGroup(groupForm, onSaved) {
        Actions.post(api, groupForm.operatingParameterTemplates, loadData)

        onSaved();

    }


    return (
        <>
            <>
                {noCard &&
                    <Col md={width} className={className}>
                        <Table
                            shadow={shadow}
                            tittle={prepareTitle(title)}
                            width={width}
                            withoutHeader={!header}
                            className={className}
                            setLoader={setLoader}
                            tableHeader={tableHeader}
                            columns={(editable || removable || additionalButtons) && (readOnly ? details : true) ? processedColumns.concat([actionsColumn]) : processedColumns}
                            initData={data}
                            reload={reload}
                            pagination={pagination}
                            externalState={externalState}
                            setExternalState={setExternalState}
                        />
                    </Col>
                }
                {!noCard &&
                    <CardTable
                        shadow={shadow}
                        tittle={prepareTitle(title)}
                        width={width}
                        withoutHeader={!header}
                        className={className}
                        setLoader={setLoader}
                        tableHeader={tableHeader}
                        columns={(editable || removable || additionalButtons) && (readOnly ? details : true) ? processedColumns.concat([actionsColumn]) : processedColumns}
                        initData={data}
                        reload={reload}
                        pagination={pagination}
                        externalState={externalState}
                        setExternalState={setExternalState}
                    />
                }
                {showModal &&
                    <ModalForm
                        modalClassName={fromModal ? "second-modal" : ""}
                        open={showModal}
                        setOpen={closeModal}
                        setLoader={setLoader}
                        size={modalSize || "md"}
                        initialData={editionItem}
                        title={editMode ? (editionTitle || t("parameters.edition")) : creationTitle}
                        fields={editMode && editionFields ? editionFields(editionItem) : creationFields}
                        customSave={onSave}
                        onFinish={() => setReload(!reload)}
                    />
                }
                {showAddFromGroupModal &&
                    <ModalForm
                        modalClassName={fromModal ? "second-modal" : ""}
                        open={showAddFromGroupModal}
                        setOpen={setShowAddFromGroupModal}
                        setLoader={setLoader}
                        size={"xl"}
                        title={t("actions.add_parameters_from_group")}
                        fields={addFromGroupFields}
                        customSave={onAddFromGroup}
                        onFinish={() => setReload(!reload)}
                        buttonsConf={{
                            save: t("common.add"),
                            cancel: t("common.cancel")
                        }}
                    />
                }
            </>


        </>
    );
};


export default FunctionalTableComponent;
